import { useFormikContext } from "formik";
import { useContext, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { AppContext } from "../../../../../appContext/AppContext";
import AutocompleteObjectV2 from "../../../../../component/AutocompleteObjectV2";
import LabelRequired from "../../../../../component/LabelRequired";
import TextField from "../../../../../component/TextField";
import { CODE } from "../../../../../utils/Constant";
import { getByIdGoiKham } from "../../../../services/KhamDoanHopDongServices";
import { QuanLyHopDongContext, QuanLyHopDongContextProps } from "../../QuanLyHopDong";
import "../QuanLyHopDong.scss";
import { GIOI_TINH_KHAM_DOAN } from "../../../../constants/PhanHeKhamDoan";

const FormThemMoiGoiKham = () => {
    const { isClickOpenEditGK, dataEditGK, setDataEditGK } =
		useContext<QuanLyHopDongContextProps>(QuanLyHopDongContext);
    const { setIsLoading } = useContext(AppContext);
    const { setValues, setFieldValue, values, errors, touched } = useFormikContext<any>();  

    useEffect(() => {
        if (isClickOpenEditGK && dataEditGK) {
            handlerEditGoiKham(dataEditGK);
        }
    }, [isClickOpenEditGK]);

    const handlerEditGoiKham = async (value: any) => {
        try {
            setIsLoading(true);

            const { data } = await getByIdGoiKham(value?.id);
            if (CODE.SUCCESS === data?.code) {
                const resultData = data?.data
                resultData.gender = {
                    id: data?.data?.gender,
                    name: data?.data?.gender
                }
                resultData.staffGroup = {
                    id: data?.data?.staffGroupId,
                    name: data?.data?.staffGroupName
                }
                resultData.division = {
                    id: data?.data?.divisionId,
                    name: data?.data?.divisionName
                }
                setDataEditGK(resultData)
                setValues(resultData);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
		<Row className="mx-1 py-2 border-bottom">
			<Col xs="3">
				<TextField
					label={
						<div>
							Mã gói khám
							<span className="text-danger"> (*)</span>
						</div>
					}
					name="code"
					labelClassName="min-w-125px"
				/>
			</Col>
			<Col xs="4">
				<TextField
					label={
						<div>
							Tên gói khám
							<span className="text-danger"> (*)</span>
						</div>
					}
					name="name"
					labelClassName="min-w-125px"
				/>
			</Col>
			<Col xs="2" className="flex align-items-center">
				<LabelRequired className="min-w-80px" label="Giới tính" isRequired />
				<AutocompleteObjectV2
					options={GIOI_TINH_KHAM_DOAN}
					value={values?.gender}
					name="gender"
					onChange={(selectedOption) => setFieldValue('gender', selectedOption)}
					isClearable={false}
					className="spaces h-29 autocomplete-custom-tiep-nhan"
					touched={touched?.gender}
					errors={errors?.gender}
				/>
			</Col>
		</Row>
	);
};

export default FormThemMoiGoiKham;

